export enum MatchContactPersonType {
  All = 'all',
  Management = 'management',
  NonManagement = 'non_management',
}

export const MATCH_CONTACT_PERSON_TYPE_I18N = {
  [MatchContactPersonType.All]: 'All',
  [MatchContactPersonType.Management]: 'Management',
  [MatchContactPersonType.NonManagement]: 'Non-Management',
};
